import { render, staticRenderFns } from "./ProfileMenuSidebar.vue?vue&type=template&id=04205af0"
import script from "./ProfileMenuSidebar.vue?vue&type=script&lang=js"
export * from "./ProfileMenuSidebar.vue?vue&type=script&lang=js"
import style0 from "./ProfileMenuSidebar.vue?vue&type=style&index=0&id=04205af0&prod&lang=less&module=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports